import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';

function Index() {
  return (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

ReactDOM.render(<Index></Index>, document.getElementById('root'));
